import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const UpdateVersion = lazy(() => import('../../pages/app_version/UpdateVersion'));

export const AppVersionImport = {
    RoutesMap,
    UpdateVersion,
}
